import type { OutreachRow } from '@discovr/types';
import type { WizardTarget } from './wizard/wizardState';

export const LOOKUP_UNSUPPORTED_COPY = 'Contact lookup is Instagram only';

/** The row's reason lookup is unavailable, or null. Go owns the rule (A-G7); `platform` is not a reliable signal. */
export function lookupNote(row: Pick<OutreachRow, 'contactLookupSupported' | 'contactLookupNote'>): string | null {
  if (row.contactLookupSupported !== false) return null;
  return row.contactLookupNote || LOOKUP_UNSUPPORTED_COPY;
}

/** An empty entry_ids means "every contactless row" server-side, so only ever send a non-empty, searchable list.
 *  Unverified (off-page) targets are skipped: their contact state is last-seen at best, and a lookup spends credit. */
export const findContactEntryIds = (targets: WizardTarget[]): string[] =>
  targets.filter((t) => !t.unverified && !t.hasContact && t.lookupSupported !== false).map((t) => t.entryId);
